import { render, staticRenderFns } from "./AnnouncementVideo.vue?vue&type=template&id=43a455c7&scoped=true&"
import script from "./AnnouncementVideo.vue?vue&type=script&lang=js&"
export * from "./AnnouncementVideo.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementVideo.vue?vue&type=style&index=0&id=43a455c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a455c7",
  null
  
)

export default component.exports